/* Tiny pub/sub so a "replay tutorial" button rendered anywhere in the app
   (e.g. the header) can re-open a specific page's tour without wiring a
   Context provider through the layout tree. Each page picks its own
   unique pageKey and subscribes via useTour(pageKey). */
const listeners = new Map();

export function startTour(pageKey) {
  const set = listeners.get(pageKey);
  if (set) set.forEach((cb) => cb());
}

export function onStartTour(pageKey, callback) {
  if (!listeners.has(pageKey)) listeners.set(pageKey, new Set());
  const set = listeners.get(pageKey);
  set.add(callback);
  return () => set.delete(callback);
}
